import { StateViewModel, InputVariableViewModel, PathViewModel } from '@/features/bots/models/designer';
import { ConditionGroup } from '@/shared/components/conditions/models/conditionGroup';
import { ConditionGroupViewModel } from '@/shared/components/conditions/models/conditionGroupViewModel';
import { ConditionViewModel } from '@/shared/components/conditions/models/conditionViewModel';
import { FlowDesignerState } from '../../../store/bot-designer';

export function pathContainsFlowVariable(path: PathViewModel, flowVariable: InputVariableViewModel): boolean {
  return path.states.some((state) => {
    return stateContainsFlowVariable(state, flowVariable);
  });
}

function stateContainsFlowVariable(state: StateViewModel, flowVariable: InputVariableViewModel): boolean {
  if (!state.storedVariable || state.storedVariable.scope !== 'flow') {
    return false;
  }
  return state.storedVariable.name === flowVariable.name;
}

export function getFlowVariablesForPath(path: PathViewModel): InputVariableViewModel[] {
  const flowVariables: InputVariableViewModel[] = [];
  path.states.forEach((state) => {
    if (state.storedVariable && state.storedVariable.scope === 'flow') {
      flowVariables.push(state.storedVariable);
    }
  });
  return flowVariables;
}

export function removeFlowVariableFromState(state: FlowDesignerState, flowVariables: InputVariableViewModel) {
  state.flowVariables = state.flowVariables.filter((flowVar) => {
    return flowVar.name !== flowVariables.name;
  });
}

export function checkPathForInvalidDecision(flowVariable: InputVariableViewModel, path: PathViewModel) {
  path.states.forEach((state) => {
    checkStateForInvalidDecisions(flowVariable, state);
  });
}

export function checkStateForInvalidDecisions(flowVariable: InputVariableViewModel, state: StateViewModel) {
  state.decisions?.forEach((decision) => {
    decision.conditions.conditions.forEach((condition: ConditionViewModel | ConditionGroupViewModel) => {
      if (conditionContainsDeletedFlowVariable(condition, flowVariable)) {
        state.invalid = true;
      }
    });
  });
}

export function conditionContainsDeletedFlowVariable(
  condition: ConditionViewModel | ConditionGroupViewModel,
  deletedFlowVariable: InputVariableViewModel,
) {
  if (ConditionGroup.isCondition(condition)) {
    if (condition.attribute === `flow.${deletedFlowVariable.name}`) {
      return true;
    }
    return false;
  }
  return (condition as ConditionGroupViewModel).conditions.some((c) => {
    conditionContainsDeletedFlowVariable(c, deletedFlowVariable);
  });
}
